export default "__VITE_PUBLIC_ASSET__3e5d72bb__"